export function Brand({ small = false }: { small?: boolean }) {
  return (
    <div className={`brand ${small ? 'brand--small' : ''}`} aria-label="ROAM GROUP">
      <span className="brand__roam">ROAM</span><span className="brand__group">GROUP</span>
    </div>
  );
}
